// Helper to lấy env với thứ tự ưu tiên: VITE_*, legacyKey, fallback
const env = (viteKey: string, legacyKey: string, fallback: string): string =>
  (import.meta.env as any)[viteKey] || (import.meta.env as any)[legacyKey] || fallback;

export const VTE_API_URL = env('VITE_API_URL', 'API_URL', 'http://localhost:5001');
export const VTE_WS_URL = env('VITE_WS_URL', 'WS_URL', VTE_API_URL);
export const VTE_PORT = env('VITE_PORT', 'PORT', '5173');
// Mặc định enable socket trong development mode, có thể override bằng env variable
export const VTE_ENABLE_SOCKET = env('VITE_ENABLE_SOCKET', 'VTE_ENABLE_SOCKET', import.meta.env.DEV ? 'true' : 'false') === 'true';
const rawAuthMode = env('VITE_AUTH_MODE', 'AUTH_MODE', 'auto').toLowerCase();
export const AUTH_MODE = (['local', 'sdpm', 'auto'].includes(rawAuthMode) ? rawAuthMode : 'auto') as 'local' | 'sdpm' | 'auto';

// Backward-compat
export const API_URL = VTE_API_URL;
export const WS_URL = VTE_WS_URL;

export const APP_NAME = 'HRM Web';
export const APP_VERSION = '1.0.0';
